import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import DocumentTitle from 'react-document-title';
import Page from 'components/Page';
import Pattern from 'components/Pattern';
import Column from 'components/Content/Column';
import Content from 'components/Content';
import WaveLink from 'components/WaveLink';
import Bottle from 'components/Bottle';

import checkMobile from 'utils/checkMobile';

import digits404 from './404.svg';

class Page404 extends React.Component {
  static contextTypes = {
    deviceType: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.props.flux.is404 = true;
  }

  componentDidMount() {
    document.body.style.backgroundColor = '#002749';
  }

  componentWillUnmount() {
    this.props.flux.is404 = false;
    document.body.style.backgroundColor = '#149BE2';
  }

  render() {
    const { deviceType } = this.context;
    const isMobile = checkMobile(deviceType, this.props.viewport);

    require('./Page404.styl');

    const textStyles = { fontSize: 15 };
    const linkStyles = {
      display: 'inline-block',
      paddingBottom: 3,
      marginTop: 10
    };

    const pageStyle = {
      backgroundImage: `url(${this.props.backgroundImage[0]})`,
      backgroundColor: '#234865'
    };

    return (
      <Page style={pageStyle} className="Page404__root">
        <DocumentTitle title="Страница не найдена" />
        {!isMobile && (
          <Pattern left="35%" colorLeft="#001f30" colorRight="#001f30" />
        )}
        {!isMobile && (
          <Pattern left="35%" colorLeft="#001f30" colorRight="transparent">
            <img src={digits404} className="Page404__404" />
          </Pattern>
        )}
        {!isMobile && (
          <Pattern
            left="35%"
            colorLeft="rgba(0, 77, 176, 0.2)"
            colorRight="rgba(0, 77, 176, 0.2)"
          />
        )}
        <Content>
          <Column>
            <div style={{ marginTop: -20 }}>
              <h2>
                Страница
                <br />
                не найдена
              </h2>
              <p style={textStyles}>
                Неправильно набран адрес, или такой
                <br />
                страницы больше не существует.
              </p>

              <Link to="/">
                <WaveLink
                  color="#20c8ff"
                  element="span"
                  style={Object.assign({}, textStyles, linkStyles)}
                >
                  Вернуться на главную
                </WaveLink>
              </Link>
            </div>
          </Column>

          {isMobile && (
            <Column className="Content__column--bottle">
              <Bottle cover={this.props.backgroundImage[1]} />
            </Column>
          )}
        </Content>
      </Page>
    );
  }
}

export default Page404;



// WEBPACK FOOTER //
// ./src/pages/Page404/Page404.js